/**
 * Feature Flags Configuration
 * 
 * Control feature visibility without code changes.
 * Set to true to enable, false to disable.
 */

// Dev-only email allowlist for debug buttons
const DEV_EMAILS = ['getradicaldude@gmail.com']; // Only this account sees debug buttons

const FEATURES = {
  // Notifications System
  // Set to true when Firebase IAM permissions are ready
  NOTIFICATIONS: false,
  
  // Payment System (Stripe)
  // Set to 'dev' for testing, 'true' for production, false to disable
  PAYMENTS: false, // Payments disabled - everyone has full access
  
  // Premium Features (requires PAYMENTS: true)
  ADVANCED_STATS: false,
  EXPORT_MATCHES: false,
  CUSTOM_BRANDING: false,
  
  // Experimental Features
  DARK_MODE: false,
  VOICE_SCORING: false,
  TOURNAMENT_MODE: false,

  // Entry-point rework — full rollout when this branch merges to main.
  // All flags 'true' so every visitor sees the new experience
  // (anon-scoring is fundamentally about NOT signing in, so dev-only
  // gating would be circular). To soft-launch a single piece in the
  // future, flip the relevant flag to 'dev' (DEV_EMAILS-only) or
  // false.
  ENTRY_POINT_REWORK: true,      // Non-auth users land on scoring surface (no auth wall)
  ANONYMOUS_SCORING: true,       // Firebase Anonymous Auth + link-on-signup
  SAVE_PROMPTS: true,            // Soft "save to your account" prompts at key moments
  GEO_BANNER: true,              // Opt-in location → "matches near you" banner
  MATCH_VENUE_TAGGING: true,     // Opt-in venue tag at match creation
  MATCH_COMPLETION_MOMENT: true, // Final whistle beat with logo reaction + share CTA
  VIEWER_PRESENCE: true          // "N watching" indicator + RTDB presence writes
};

/**
 * Check if a feature is enabled
 * @param {string} feature - Feature name from FEATURES object
 * @param {Object} user - Current user object (for dev mode checks)
 * @returns {boolean}
 */
export const isFeatureEnabled = (feature, user = null) => {
  const featureValue = FEATURES[feature];
  
  // Dev mode: only enable for developer emails
  if (featureValue === 'dev') {
    return user?.email && DEV_EMAILS.includes(user.email);
  }
  
  return featureValue === true;
};

/**
 * Get all enabled features
 * @returns {string[]} Array of enabled feature names
 */
export const getEnabledFeatures = () => {
  return Object.keys(FEATURES).filter(key => FEATURES[key] === true);
};

/**
 * Check if user has access to premium features
 * @param {Object} user - Current user object
 * @returns {boolean}
 */
export const hasPremiumAccess = (user) => {
  // If payments feature is not enabled (for this user), everyone has access
  if (!isFeatureEnabled('PAYMENTS', user)) return true;
  
  // When PAYMENTS is enabled, check user.subscription.status
  return user?.subscription?.status?.includes('pro') || false;
};

export default FEATURES;


